import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    minHeight: 30,
    padding: "8px 16px"
  },
  listItemLabel: {
    marginRight: 12,
    lineHeight: 1,
    fontSize: 12
  },
  listItemValue: {
    lineHeight: 1,
    textAlign: "right",
    fontSize: 12,
    wordBreak: "break-word"
  }
}));
